 /* This script dynamically sets the Okta URLs based on the current domain. Currently, it is used only for the CitusHealth production environment. 
 Okta environment values are configured here, and new configurations will be added if Okta branding is to be used. */

currentDomain = window.location.hostname;
domainParts = currentDomain.split('.');
topLevelDomain = domainParts[domainParts.length - 1];
const protocol = window.location.protocol;

// Function to generate dynamic redirect URIs based on current domain
function generateRedirectUris() {
    return {
        redirectUri: `${protocol}//${currentDomain}/login/callback`,
        postLogoutRedirectUri: `${protocol}//${currentDomain}/login`
    };
}

const redirectUris = generateRedirectUris();

window.oktaBrandingUrls = {
    'citushealth' : {
        oktaBaseUrl: `https://login.citushealth.${topLevelDomain}`,
        oktaIssuer: `https://login.citushealth.${topLevelDomain}/oauth2/ausuou1tfqmwwLQ3U297`,
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'qa': {
        oktaBaseUrl: `https://login-qa.citushealth.${topLevelDomain}`,
        oktaIssuer: `https://login-qa.citushealth.${topLevelDomain}/oauth2/aus23980h1beaxq5F0h8`,
        oktaClientId: '0oa2397jm8iuo9Lkc0h8',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'uat': {
        oktaBaseUrl: `https://login-uat.citushealth.${topLevelDomain}`,
        oktaIssuer: `https://login-uat.citushealth.${topLevelDomain}/oauth2/aus23980h1beaxq5F0h8`,
        oktaClientId: '0oa2397jm8iuo9Lkc0h8',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'stage': {
        oktaBaseUrl: `https://login-stage.citushealth.${topLevelDomain}`,
        oktaIssuer: `https://login-stage.citushealth.${topLevelDomain}/oauth2/aus259idzbxWzcWC20h8`,
        oktaClientId: '0oa259ifkj6T8Bvyd0h8',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'uat-ca': {
        oktaBaseUrl: `https://login-uat.citushealth.${topLevelDomain}`,
        oktaIssuer: `https://login-uat.citushealth.${topLevelDomain}/oauth2/aus259idzbxWzcWC20h8`,
        oktaClientId: '0oa259ifkj6T8Bvyd0h8',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'branded-app': {
        oktaBaseUrl: `https://dev-877297.oktapreview.${topLevelDomain}`,
        oktaIssuer: `https://dev-877297.oktapreview.${topLevelDomain}/oauth2/aus23980h1beaxq5F0h8`,
        oktaClientId: '0oa2397jm8iuo9Lkc0h8',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'matrixcare': {
        oktaBaseUrl: `https://login-matrixcare.citushealth.${topLevelDomain}`,
        oktaIssuer: `https://login-matrixcare.citushealth.${topLevelDomain}/oauth2/ausuou1tfqmwwLQ3U297`,
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'kabafusion': {
        oktaBaseUrl: 'https://mylogin.kabafusion.com',
        oktaIssuer: 'https://mylogin.kabafusion.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'kennebec': {
        oktaBaseUrl: 'https://login-connect.kennebecpharmacy.com',
        oktaIssuer: 'https://login-connect.kennebecpharmacy.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'orsini': {
        oktaBaseUrl: 'https://login-app.orsini.com',
        oktaIssuer: 'https://login-app.orsini.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'realo': {
        oktaBaseUrl: 'https://login-realo.citushealth.com',
        oktaIssuer: 'https://login-realo.citushealth.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'myanovo': {
        oktaBaseUrl: 'https://login-anovorx.citushealth.com',
        oktaIssuer: 'https://login-anovorx.citushealth.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'nutrishare': {
        oktaBaseUrl: 'https://login-care.nutrishare.com',
        oktaIssuer: 'https://login-care.nutrishare.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'medrx': {
        oktaBaseUrl: 'https://login-medrxinfusion.citushealth.com',
        oktaIssuer: 'https://login-medrxinfusion.citushealth.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'ascellahealth': {
        oktaBaseUrl: 'https://login-connect.ascellahealth.com',
        oktaIssuer: 'https://login-connect.ascellahealth.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'specialityapp': {
        oktaBaseUrl: 'https://login-specialityapp.citushealth.com',
        oktaIssuer: 'https://login-specialityapp.citushealth.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'fillpoint': {
        oktaBaseUrl: 'https://login-fillpoint.citushealth.com',
        oktaIssuer: 'https://login-fillpoint.citushealth.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'soleoconnect': {
        oktaBaseUrl: 'https://login.soleoconnect.com',
        oktaIssuer: 'https://login.soleoconnect.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'premier': {
        oktaBaseUrl: 'https://login-patients.premierhcs.com',
        oktaIssuer: 'https://login-patients.premierhcs.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'rxtogo': {
        oktaBaseUrl: 'https://login.rxtogoconnect.flcancer.com',
        oktaIssuer: 'https://login.rxtogoconnect.flcancer.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    },
    'vitalcare': {
        oktaBaseUrl: 'https://login-connect.vitalcare.com',
        oktaIssuer: 'https://login-connect.vitalcare.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaRedirectUri: redirectUris.redirectUri,
        oktaPostLogoutRedirectUri: redirectUris.postLogoutRedirectUri
    }
};
// IDM SSO IDP integration with custom OAuth2 flow - Environment-based configuration
window.oauth2IdpConfigs = {
    'engage-eforms-qa.matrixcare.com': {
        oktaBaseUrl: 'https://dev-877297.oktapreview.com',
        oktaClientId: '0oa2397jm8iuo9Lkc0h8',
        oktaIssuer: 'https://dev-877297.oktapreview.com/oauth2/aus23980h1beaxq5F0h8',
        oktaRedirectUri: `${protocol}//engage-eforms-qa.matrixcare.com/oauth2/callback`
    },
    'engage-eforms-stage.matrixcare.com': {
        oktaBaseUrl: 'https://matrixcare.oktapreview.com',
        oktaClientId: '0oa259ifkj6T8Bvyd0h8',
        oktaIssuer: 'https://matrixcare.oktapreview.com/oauth2/aus259idzbxWzcWC20h8',
        oktaRedirectUri: `${protocol}//engage-eforms-stage.matrixcare.com/oauth2/callback`
    },
    'engage-eforms.matrixcare.com': {
        oktaBaseUrl: 'https://matrixcare.okta.com',
        oktaClientId: '0oauou29uw9JepSjh297',
        oktaIssuer: 'https://matrixcare.okta.com/oauth2/ausuou1tfqmwwLQ3U297',
        oktaRedirectUri: `${protocol}//engage-eforms.matrixcare.com/oauth2/callback`
    }
};

// Function to get OAuth2 IDP config based on current domain
function getOAuth2IdpConfig() {
    const config = window.oauth2IdpConfigs[currentDomain];
    if (config) {
        return config;
    }
    // Fallback to QA config for development/testing
    return window.oauth2IdpConfigs['engage-eforms-qa.matrixcare.com'];
}

// Set the active OAuth2 IDP config based on current domain
window.oauth2IdpConfig = getOAuth2IdpConfig();



// WEBPACK FOOTER //
// src/assets/lib/okta-branding.js